import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  Pipe,
} from "@angular/core";

const ASSETS_ROOT = "assets/icons/";

import type { PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({
  name: "svgContent",
})
export class SvgContentPipe implements PipeTransform {
  private readonly domSanitizer = inject(DomSanitizer);

  transform(path: string) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(
      `${ASSETS_ROOT}${path}.svg`,
    );
  }
}

@Component({
  selector: "oui-icon",
  host: {
    class: "inline-block",
  },
  template: `
    <img class="max-h-full w-full" [alt]="alt()" [src]="svg() | svgContent" />
  `,
  imports: [SvgContentPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  readonly svg = input.required<string>();
  readonly size = input("16px");
  readonly alt = input("illustration icon");
  readonly aspectRatio = input<string>("1 / 1");
}
